import React, { useEffect } from 'react';
import TaskDetailCore from './TaskDetailCore';
import './TaskDetailModal.css';

/**
 * TaskDetailModal - Modal overlay wrapper for task details
 * Used when tasks are opened from Sprint Board
 *
 * Supports both old (taskId) and new (identifier/identifierType) props
 *
 * Features:
 * - Full-screen overlay with backdrop
 * - Close via X button only
 * - Prevents body scroll while open
 */
const TaskDetailModal = ({ taskId, identifier, identifierType = 'id', onClose, onDeleted }) => {
  // Support both old and new props
  const effectiveTaskId = identifier || taskId;
  // Prevent body scroll and compensate for scrollbar width to avoid layout shift
  useEffect(() => {
    // Calculate scrollbar width before hiding it
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

    // Prevent body scroll
    document.body.style.overflow = 'hidden';

    // Add padding to compensate for scrollbar removal (prevents layout shift)
    if (scrollBarWidth > 0) {
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    }

    return () => {
      // Restore body scroll and remove padding
      document.body.style.overflow = 'unset';
      document.body.style.paddingRight = '0px';
    };
  }, []);

  return (
    <div className="task-modal-overlay">
      <div
        className="task-modal-container"
        role="dialog"
        aria-modal="true"
        aria-labelledby="task-modal-title"
      >
        {/* Close button */}
        <button
          className="task-modal-close"
          onClick={onClose}
          aria-label="Close modal"
          title="Close"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"/>
          </svg>
        </button>

        {/* Scrollable content */}
        <div className="task-modal-content">
          <TaskDetailCore
            identifier={effectiveTaskId}
            identifierType={identifierType}
            taskId={taskId}
            renderMode="modal"
            onClose={onClose}
            onDeleted={onDeleted}
          />
        </div>
      </div>
    </div>
  );
};

export default TaskDetailModal;
